import { trans } from "@mongez/localization";
import { ChevronRightIcon } from "lucide-react";
import { SectorItem as SectorItemType } from "../types";

type SectorItemsSectionProps = {
  items: SectorItemType[];
};

export function SectorItemsSection({ items }: SectorItemsSectionProps) {
  return (
    <div className="bg-marine">
      <div className="container flex flex-col gap-6 pt-12 lg:pt-24">
        <div className="flex flex-col gap-6">
          {items.map((item) => (
            <SectorItem key={item.id} item={item} />
          ))}
        </div>
      </div>
    </div>
  );
}

type SectorItemProps = {
  item: SectorItemType;
};

export function SectorItem({ item }: SectorItemProps) {
  return (
    <div className="relative flex w-full flex-col gap-6 overflow-hidden rounded-[40px] bg-white p-6 lg:p-11">
      <span className="absolute top-14 h-10 w-10 rounded-full bg-bright-orange ltr:left-0 ltr:-translate-x-1/2 rtl:right-0 rtl:translate-x-1/2" />
      {/* Card Header (Image and Title) */}
      <div className="relative flex flex-col gap-4 lg:flex-row lg:items-center">
        <div className="h-14 w-60 shrink-0 overflow-hidden">
          <img
            src={item.image.url}
            alt={item.image.name}
            width={280}
            height={60}
            className="h-full w-full object-contain"
          />
        </div>
        <a target="_blank" href={item.link} className="flex flex-col gap-1">
          <h2 className="flex items-center gap-4 text-lg font-bold text-marine sm:text-xl lg:text-2xl">
            <span className="block ltr:mt-1">{trans(item.title)}</span>
            <ChevronRightIcon className="size-6 rtl:rotate-180" />
          </h2>
          {item.subtitle && (
            <h3 className="text-sm font-semibold text-marine sm:text-base lg:text-lg">
              {trans(item.subtitle)}
            </h3>
          )}
        </a>
      </div>
      {/* Card Content (Description) */}
      {/* <div
        className="prose min-w-full prose-p:text-lg prose-p:text-neutral-500"
        dangerouslySetInnerHTML={{ __html: item.content }}
      /> */}
      <div className="text-sm text-neutral-500 sm:text-base lg:text-lg">
        {trans(item.content)}
      </div>
    </div>
  );
}
